module.exports = __webpack_public_path__ + "img/error.09036ed6.svg";